<template lang="">
    <div id="viewDiv" class="mb-8"></div>
</template>
<script>
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import Search from "@arcgis/core/widgets/Search";
import BasemapToggle from "@arcgis/core/widgets/BasemapToggle";
import * as locator from "@arcgis/core/rest/locator";
import esriConfig from "@arcgis/core/config.js";
import esriConfigJson from "@/config/esri.config.json";
import Graphic from "@arcgis/core/Graphic";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";

let GIS = {};
const serviceUrl =
  "http://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer";

const marker = {
  type: "simple-marker",
  style: "circle",
  color: "#1855C5",
  size: "16px",
  outline: {
    color: "#75A0F0",
    width: 3,
  },
};

const popupTemplate = {
  title: "{Address}",
  content: "{Description}",
};

export default {
  name: "LocationMap",
  props: {
    viewMode: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
      default: () => {},
    },
    address: {
      type: String,
      default: "",
    },
    locations: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    locations(newVal) {
      this.showAddresses(newVal);
    }
  },
  data () {
    return {
      locationsList: this.locations
    }
  },
  methods: {
    setSelectedAddress(data) {
      this.$emit("selectLocation", data);
    },
    getLocationToAddress(evt) {
      const params = {
        location: evt.mapPoint,
      };
      locator.locationToAddress(serviceUrl, params).then(
        (response) => {
          // Show the address found
          const address = response.address;
          this.setSelectedAddress(response);
          this.showAddress(address, response.location);
        },
        (err) => {
          // Show no address found
          this.showAddress(this.$t("ERRORS.ATLAS_NO_SEARCH_RESULT"), evt.mapPoint);
        }
      );
    },
    showAddresses(locations) {
        GIS.graphicsLayer.removeAll();
        locations.forEach((location) => {
            const address = location.complain.address;
            const coordonates = location.complain.location;
            const multipleLocations = true;
            this.showAddress(address, coordonates, multipleLocations);
        })
    },
    showAddress(address, pt, multipleLocations = false) {
      if(!multipleLocations) {
          GIS.graphicsLayer.removeAll();
      }
        // Create a point
        const point = {
          type: "point",
          longitude: pt.longitude,
          latitude: pt.latitude,
        };
        const popupDescription = `${pt.longitude}, ${pt.latitude}`;

        const attributes = {
          Address: this.address,
          Description: popupDescription,
        };

        const pointGraphic = new Graphic({
          geometry: point,
          symbol: marker,
          attributes,
          popupTemplate,
        });

        GIS.graphicsLayer.add(pointGraphic);

        if (this.viewMode && !multipleLocations) {
          GIS.view.center = [pt.longitude, pt.latitude];
          GIS.view.zoom = 17;
        }
        if (!multipleLocations) {
            GIS.view.popup.open({
                title: address,
                content: popupDescription,
                location: pt,
            });
        }
    },
  },
  mounted() {
    esriConfig.apiKey = esriConfigJson.apiKey;
    const map = new Map({
      basemap: "arcgis-topographic",
    });

    const view = new MapView({
      container: "viewDiv",
      map: map,
      center: [23.5889, 46.7698],
      zoom: 11,
    });

    //basemap toggle
    const basemapToggle = new BasemapToggle({
      view: view,
      nextBasemap: "arcgis-imagery",
    });
    view.ui.add(basemapToggle, "bottom-right");

    const graphicsLayer = new GraphicsLayer();
    map.add(graphicsLayer);

    GIS.map = map;
    GIS.view = view;
    GIS.graphicsLayer = graphicsLayer;

    if (this.viewMode) {
        if (this.address && this.location) {
            this.showAddress(this.address, this.location);
        }
        if (this.locations.length > 0) {
            this.showAddresses(this.locations) ;
        }
    } else {
      // Add Search widget
      const search = new Search({
        view: view,
      });
      view.ui.add(search, "top-right");

      view.on("click", this.getLocationToAddress);
    }
  },
};
</script>
<style>
/* esri styles */
@import url("https://js.arcgis.com/4.20/esri/themes/light/main.css");

#viewDiv {
  height: 600px;
}
</style>
